import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { Button } from './ui/button';

const BACKEND_URL = window.location.origin;

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState('polling');
  const [bookId, setBookId] = useState(null);
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) {
      setStatus('error');
      return;
    }

    const poll = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/stripe/checkout-status/${sessionId}`, {
          credentials: 'include'
        });
        const data = await res.json();

        if (data.payment_status === 'paid') {
          setStatus('success');
          setBookId(data.book_id);
          return;
        }
        if (data.status === 'expired') {
          setStatus('expired');
          return;
        }

        // Keep polling
        if (attempts < 10) {
          setTimeout(() => setAttempts(prev => prev + 1), 2000);
        } else {
          setStatus('timeout');
        }
      } catch {
        setStatus('error');
      }
    };

    poll();
  }, [sessionId, attempts]);

  return (
    <div className="min-h-screen bg-[#0f0a1a] flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        {status === 'polling' && (
          <>
            <Loader2 className="w-16 h-16 text-pink-500 animate-spin mx-auto mb-6" />
            <h1 className="text-2xl font-bold text-white mb-2" dir="rtl">جاري التحقق من الدفع...</h1>
            <p className="text-gray-400">Verifying your payment, please wait...</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="w-10 h-10 text-green-500" />
            </div>
            <h1 className="text-2xl font-bold text-white mb-2" dir="rtl">تمت عملية الدفع بنجاح!</h1>
            <p className="text-gray-400 mb-8">Payment successful! Your book is now available.</p>
            <div className="flex gap-3 justify-center">
              <Link to="/#books">
                <Button className="bg-pink-600 hover:bg-pink-700">
                  العودة إلى المكتبة
                </Button>
              </Link>
            </div>
          </>
        )}

        {(status === 'error' || status === 'expired' || status === 'timeout') && (
          <>
            <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <XCircle className="w-10 h-10 text-red-500" />
            </div>
            <h1 className="text-2xl font-bold text-white mb-2" dir="rtl">خطأ في عملية الدفع</h1>
            <p className="text-gray-400 mb-8">
              {status === 'expired' ? 'Payment session expired.' : 
               status === 'timeout' ? 'Payment verification timed out.' : 
               'Something went wrong.'}
            </p>
            <Link to="/#books">
              <Button className="bg-pink-600 hover:bg-pink-700">
                العودة إلى المكتبة
              </Button>
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;
